export default function(zip, country) {
    let valid = "0123456789-"
    let hyphencount = 0
    let allowedCountries = ["USA", "Canada", "United Kingdom", "Germany", "Italy", "Spain", "France"]

    if (zip.length === 0) {
        return true
    }
    //ADD LOGIC FOR COUNTRY SELECTED - Don't validate unless it's USA,Canada,United Kingdom,Germany,Italy,Spain,France

    if (allowedCountries.includes(country)) {

       if (country === "USA") {
            if (zip.length !== 5 && zip.length !== 10) {
                return false
            }
            for (let i = 0; i < zip.length; i++) {
                let temp = "" + zip.substring(i, i + 1)
                if (temp === "-") {
                    hyphencount++
                }

                if (valid.indexOf(temp) === "-1") {
                    return false
                }
                if ((hyphencount > 1) || ((zip.length === 10) && "" + zip.charAt(5) !== "-")) {
                    return false
                }
            } //end for loop
        } //end elseif
        else if (country === "Canada") {
            let zipfalse = true
            zip = zip.val().toUpperCase() //in case of lowercase

            let strlen = zip.length
            if (strlen !== 7) {
                zipfalse = false
            }

            //Check for legal characters,index starts at zero "A0A 0A0"
            let s1 = 'ABCEGHJKLMNPRSTVXY '
            let s2 = s1 + 'WZ'
            let d3 = '0123456789'
            let s3 = ' '
            if (s1.indexOf(zip.charAt(0)) < 0) {
                zipfalse = false
            }
            if (d3.indexOf(zip.charAt(1)) < 0) {
                zipfalse = false
            }
            if (s2.indexOf(zip.charAt(2)) < 0) {
                zipfalse = false
            }
            if (s3.indexOf(zip.charAt(3)) < 0) {
                zipfalse = false
            }
            if (d3.indexOf(zip.charAt(4)) < 0) {
                zipfalse = false
            }
            if (s2.indexOf(zip.charAt(5)) < 0) {
                zipfalse = false
            }
            if (d3.indexOf(zip.charAt(6)) < 0) {
                zipfalse = false
            }

            if (!zipfalse) {
                return false
            }
        } //else if
    } //end if country code
    else {
        //Zip.removeClass("mktFReq")
    }
    return true
} //end function